import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import type VueI18n from 'vue-i18n';

// getCurrentInstance needed to access global $t/$route properties
// TODO: Once on Vue 3, vue-i18n version 9 and vue-router version 4 please
// use this clearer approach (not possible with current vue version):
// 1. import { useI18n } from 'vue-i18n' / import { useRoute } from 'vue-router';
// 2. const { t } = useI18n() / const route = useRoute();
// 3. t('UI.tabs.bookings') / route.name;
type PathKey = typeof KEY_BOOKING | typeof KEY_MY_PROFILE | typeof KEY_BOOKING_SEARCH;

interface LinkTab {
  key: PathKey;
  text: string | VueI18n.TranslateResult;
  path: string;
  isExternal: boolean;
}

interface PathMap {
  KEY_BOOKING: string;
  KEY_MY_PROFILE: string;
  KEY_BOOKING_SEARCH: string;
}

interface NavbarTabsProps {
  bookingLink?: string;
  myProfileLink?: string;
  bookingSearchLink?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'navbar-tabs',
  props: {
    bookingLink: { default: '' },
    myProfileLink: { default: '' },
    bookingSearchLink: { default: '' }
  },
  setup(__props: any) {

const props = __props as { bookingLink: string, myProfileLink: string, bookingSearchLink: string };

const instance = getCurrentInstance();
const vm = instance?.proxy as Vue;

const KEY_BOOKING = 'KEY_BOOKING' as const
const KEY_MY_PROFILE = 'KEY_MY_PROFILE' as const
const KEY_BOOKING_SEARCH = 'KEY_BOOKING_SEARCH' as const



const tabs = computed<LinkTab[]>(() => {
  const tabs: Array<LinkTab> = [];

  if (props.bookingLink) {
    tabs.push({
      key: KEY_BOOKING,
      text: vm.$t('UI.tabs.bookings'),
      path: getPath(KEY_BOOKING),
      isExternal: checkIsExternal(KEY_BOOKING)
    })
  }

  if (props.myProfileLink) {
    tabs.push({
      key: KEY_MY_PROFILE,
      text: vm.$t('UI.tabs.myProfile'),
      path: getPath(KEY_MY_PROFILE),
      isExternal: checkIsExternal(KEY_MY_PROFILE)
    })
  }

  if (props.bookingSearchLink) {
    tabs.push({
      key: KEY_BOOKING_SEARCH,
      text: vm.$t('UI.tabs.myBookings'),
      path: getPath(KEY_BOOKING_SEARCH),
      isExternal: checkIsExternal(KEY_BOOKING_SEARCH)
    })
  }

  return tabs;
})

const displayTabs = computed<string>(() => {
  return props.bookingLink || props.myProfileLink || props.bookingSearchLink;
})

const getRouteType = computed<string>(() => {
  const routerName = vm.$route.name;

  if (routerName === 'index') {
    return KEY_BOOKING
  }

  if (routerName === 'my-profile') {
    return KEY_MY_PROFILE
  }

  return '';
})

const areTabsDark = computed<string>(() => {
  return props.bookingSearchLink;
})

const pathMap = computed<PathMap>(() => {
  return {
    KEY_BOOKING: props.bookingLink,
    KEY_MY_PROFILE: props.myProfileLink,
    KEY_BOOKING_SEARCH: props.bookingSearchLink
  }
})

const getPath = (key: PathKey): string => {
  return pathMap.value[key];
}

const checkIsExternal = (key: PathKey): boolean => {
  const path = pathMap.value[key];
  return path.includes('http');
}

return { __sfc: true,instance, vm, KEY_BOOKING, KEY_MY_PROFILE, KEY_BOOKING_SEARCH, props, tabs, displayTabs, getRouteType, areTabsDark, pathMap, getPath, checkIsExternal }
}

})